export default __webpack_public_path__ + "static/media/gallery_02.b2bd4de1.jpg";